define('enums/participantStatus',[],function () {
    'use strict';

    return {
        ALERTING: 'ALERTING',
        CONNECTING: 'CONNECTING',
        CONNECTED: 'CONNECTED',
        CONTACTING: 'CONTACTING',
        DIALING: 'DIALING',
        DISCONNECTED: 'DISCONNECTED',
        OFFERING: 'OFFERING',
        TERMINATED: 'TERMINATED'
    };
});
